import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { navigate } from "@reach/router";
import React, { useEffect } from "react";
import { addUsers, sendMessage } from "../../../config/services";
//import { addUsers } from "../../config/services";

export const UploadPhoto = ({ encodedimageurl, userid }) => {
  useEffect(() => {
    var decodeImage = atob(encodedimageurl);
    console.log(decodeImage);
    console.log(userid);

    addUsers(userid, {
      image: decodeImage,
      kyc_verified: true,
      image_url: decodeImage,
    })
      .then(() => {
        sendMessage(
          `KYC request from user`,
          "KYC Request",
          "financeservice076@gmail.com",
          `User`
        )
          .then(() => {
            navigate("../../");
          })
          .catch((err) => {
            console.log(err);
            navigate("../../");
          });
      })
      .catch((err) => console.log(err));
  });

  return (
    <Backdrop
      sx={{
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      <CircularProgress color="primary" />
      <Box mt={1}>
        <Typography variant="h6">Uploading ID photo</Typography>
      </Box>
    </Backdrop>
  );
};
